import { createSelector } from 'reselect';
import { dialogsSelector } from './dialogs';

export const activeDialogsSelector = createSelector(dialogsSelector, (dialogs) =>
    Object.values(dialogs).filter((dialog) => dialog.active),
);
